import axios from "axios";
import { apiURL } from "../constants";

const refreshTokenInstance = axios.create({
    baseURL: apiURL,
    timeout: 0,
    headers: {
        "Content-Type": "application/json; charset=UTF-8",
        "Accept": "application/json; charset=UTF-8",
        "Referrer-Policy": "strict-origin-when-cross-origin",
        "Cache-Control": "no-cache",
    },
    withCredentials: true,
    responseEncoding: "utf8",
    responseType: "json",
});

const refreshToken = async (token) => {
    try {
        refreshTokenInstance.defaults.headers['Authorization'] = "Bearer " + token;
        const response = await refreshTokenInstance.post('auth/refresh');
        if(response?.status === 200) {
            return response.data.authorization.token;
        }
    } catch (error) {
        throw error;
    }
}

export default refreshToken;